import { z } from "zod";
import { statusNaBaseSchema, tipoNaBaseSchema } from "./rotulos";

const id = z.string().min(1);
const nome = z.string().trim().min(1, "Informe o nome").max(160);
const perfis = z.array(z.string().min(1)).default([]);
const opcional = z.string().trim().max(80).nullish();

/** O item da base como o editor do admin lê e grava — uma forma por tipo. */
export const itemDaBaseSchema = z.discriminatedUnion("tipo", [
  z.object({
    tipo: z.literal("servicos"),
    id: id.optional(),
    nome,
    /** Nome da categoria: existente ou nova (criada ao salvar). */
    categoria: z.string().trim().min(1, "Informe a categoria").max(120),
    abrangencia: z.enum(["DENTE", "ARCADA"]),
    perfis,
    /** Materiais compatíveis (BaseMaterial). As químicas do serviço saem deles. */
    materialIds: z.array(id).default([]),
  }),
  z.object({ tipo: z.literal("materiais"), id: id.optional(), nome, materialCategoryId: id, familia: z.string().nullish(), perfis }),
  z.object({
    tipo: z.literal("insumos"),
    id: id.optional(),
    nome,
    tipoDeInsumo: z.enum(["PRODUTO", "CONSUMIVEL"]),
    /** Nome do fabricante: existente ou novo. */
    fabricante: z.string().trim().min(1, "Informe o fabricante").max(120),
    materialCategoryId: id,
    formato: opcional,
    translucidez: opcional,
    unidade: opcional,
    categoriaSugerida: opcional,
    perfis,
    usadoComIds: z.array(id).default([]),
    equipamentoIds: z.array(id).default([]),
  }),
  z.object({ tipo: z.literal("quimicas"), id: id.optional(), nome, familia: z.string().nullish() }),
  z.object({ tipo: z.literal("cores"), id: id.optional(), escalaId: id, cor: z.string().trim().min(1).max(20) }),
  z.object({
    tipo: z.literal("procedimentos"),
    id: id.optional(),
    nome,
    /** Especialidade principal — agrupa o procedimento nas telas da clínica. */
    especialidadeId: z.string().min(1, "Escolha a especialidade principal"),
    abrangencia: z.enum(["DENTE", "FACE", "ARCADA", "BOCA"]),
    codigoTuss: z.string().trim().max(20).nullish(),
    unidade: z.string().trim().max(20).nullish(),
    duracaoMinutos: z.number().int().min(5).max(600).nullish(),
    cor: z.string().trim().max(20).nullish(),
    especialidadeIds: z.array(id).default([]),
  }),
  z.object({ tipo: z.literal("especialidades"), id: id.optional(), nome, destaque: z.boolean() }),
  z.object({
    tipo: z.literal("equipamentos"),
    id: id.optional(),
    nome,
    tipoDeEquipamento: z.string().min(1, "Informe o tipo"),
    perfis,
    quimicaIds: z.array(id).default([]),
  }),
]);
export type ItemDaBase = z.infer<typeof itemDaBaseSchema>;
export type ItemDaBaseEntrada = z.input<typeof itemDaBaseSchema>;

export const mudarStatusNaBaseSchema = z.object({
  tipo: tipoNaBaseSchema,
  ids: z.array(id).min(1).max(500),
  status: statusNaBaseSchema,
});
